import React from "react";
import StockCardView from "../cards/StockCardView";

/**
 * Component to render the list of available stocks
 * Handles ROI calculation and stock card rendering
 */
const StocksList = ({
  stocks,
  indexes,
  playerPortfolios,
  stockOwnershipCounts,
  stockOwnershipByPlayer,
  playerColors,
  playerEmojis,
  myTurn,
  actionsRemaining,
  name,
  actionMode,
  selectedActionCard,
  onPurchase,
  onSell,
  styleCardSize,
  roundNumber,
  onForcedSale
}) => {
  return (
    <div className="playerCards flex flex-wrap gap-sm justify-center" data-tutorial="stocks">
      {stocks.map((stock, idx) => {
        const ownedStock =
          (playerPortfolios[name] || []).find(
            (owned) => owned.name === stock.name
          ) || null;

        // Check if trading is blocked on this stock
        const isTradingBlocked = (stock.appliedActionCards || []).some(
          card => card.actionType === 'trading_halt'
        );

        const canSellThis =
          myTurn &&
          (actionsRemaining[name] || 0) > 0 &&
          (ownedStock || actionMode === "selecting_stock_down") &&
          !isTradingBlocked;

        // Calculate ROI for stocks based on last purchased share
        const playerStocks = (playerPortfolios[name] || []).filter(
          (owned) => owned.name === stock.name
        );
        const sortedStocks = [...playerStocks].sort((a, b) => 
          (a.purchaseRound || 0) - (b.purchaseRound || 0)
        );
        const lastPurchasedStock = sortedStocks.length > 0 
          ? sortedStocks[sortedStocks.length - 1] 
          : null;
        
        const relatedIndex = indexes.find(idx => idx.name === stock.industrySector);
        const indexPrice = relatedIndex ? relatedIndex.price : 0;
        const stocksOwned = stockOwnershipCounts[stock.name] || 0;
        
        const manipulatorEffect = (stock.appliedActionCards || [])
          .filter(card => {
            if (card.actionType === 'manipulate') {
              return true;
            }
            if (card.actionType === 'delayed_manipulate') {
              return card.processed === true;
            }
            return false;
          })
          .reduce((sum, card) => sum + (card.effectValue || 0), 0);
        
        const marketPrice = (stock.baseCost || 0) + indexPrice + ((stock.growth || 0) * stocksOwned) + manipulatorEffect;
        const rawSellPrice = marketPrice - (stock.growth || 0);
        const sellPrice = Math.max(1, rawSellPrice);
        
        const roi = lastPurchasedStock && lastPurchasedStock.purchasePrice && sellPrice
          ? (sellPrice - lastPurchasedStock.purchasePrice).toFixed(2)
          : null;

        return (
          <StockCardView
            key={`${stock.name}-${idx}`}
            stock={stock}
            indexes={indexes}
            styleCardSize={styleCardSize}
            onPurchase={onPurchase}
            onSell={onSell}
            canPurchase={myTurn && (actionsRemaining[name] || 0) > 0 && !isTradingBlocked}
            canSell={canSellThis}
            ownedStock={ownedStock}
            stockOwnershipCounts={stockOwnershipCounts}
            stockOwnershipByPlayer={stockOwnershipByPlayer[stock.name] || {}}
            playerPortfolios={playerPortfolios}
            playerColors={playerColors}
            playerEmojis={playerEmojis}
            actionMode={actionMode}
            selectedActionCard={selectedActionCard}
            roi={roi}
            myTurn={myTurn}
            roundNumber={roundNumber}
            currentPlayerName={name}
            onForcedSale={onForcedSale}
          />
        );
      })}
    </div>
  );
};

export default StocksList;

